var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 9C27.597 9 27 9.54197 27 10.2105C27 10.8791 27.597 11.4211 28.3333 11.4211H30.3333V30.7895C30.3333 31.458 30.9303 32 31.6667 32C32.403 32 33 31.458 33 30.7895V10.2105C33 9.54197 32.403 9 31.6667 9H28.3333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23077 15.7826C2.55103 15.7826 2 16.3277 2 17V29.7826C2 30.455 2.55103 31 3.23077 31H6.30769C6.98743 31 7.53846 30.455 7.53846 29.7826V17C7.53846 16.3277 6.98743 15.7826 6.30769 15.7826H3.23077Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 31C9.32027 31 8.76923 30.4549 8.76923 29.7826V4.21739C8.76923 3.54504 9.32027 3 10 3H24.7692C25.449 3 26 3.54504 26 4.21739V29.7826C26 30.4549 25.449 31 24.7692 31H21.2266C20.5469 31 19.9958 30.4549 19.9958 29.7826V26.2101C19.9958 25.5377 19.4448 24.9927 18.765 24.9927H16.1153C15.4356 24.9927 14.8845 25.5377 14.8845 26.2101V29.7826C14.8845 30.4549 14.3335 31 13.6538 31H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.5c9ac098ada23324f83ad3d00c4af09c.svg";
export { ForwardRef as ReactComponent };